/**
 * 판정 기준:
 * - lastSeenAt이 없거나 유효하지 않으면 오프라인 (false)
 * - lastSeenAt이 정확히 thresholdMs 이내면 온라인 (true), 초과면 오프라인 (false)
 *
 * @param lastSeenAt Date 문자열 또는 null/undefined
 * @param thresholdMs 온라인 판정 임계치 (ms)
 * @param now 현재 시각 (ms)
 */
export const isDaemonOnline = (
  lastSeenAt: string | null | undefined,
  thresholdMs: number,
  now: number = Date.now(),
): boolean => {
  if (!lastSeenAt) {
    return false;
  }
  const lastSeenTime = new Date(lastSeenAt).getTime();
  if (!Number.isFinite(lastSeenTime)) {
    return false;
  }
  return now - lastSeenTime <= thresholdMs;
};

/**
 * 기본 온라인 판정 임계값 (150초)
 * 서버 응답 로딩 전이거나 메타데이터가 누락되었을 때 폴백으로 사용한다.
 */
export const DEFAULT_DAEMON_ONLINE_THRESHOLD_MS = 150_000;
